import { UserLoan } from '@matech/thebigpos-sdk'

export const getBorrowerUserFromLoanList = (
	userLoans: UserLoan[]
) => {
	return (
		userLoans?.find((item) => item?.role === 'Borrower')?.user ?? null
	)
}

export const getCoBorrowerUserFromLoanList = (
	userLoans: UserLoan[]
) => {
	return (
		userLoans?.find((item) => item?.role === 'CoBorrower')?.user ??
		null
	)
}

export const getBorrowerAndCoBorrowerUserFromLoanList = (
	userLoans: UserLoan[]
) => ({
	borrower: getBorrowerUserFromLoanList(userLoans),
	coBorrower: getCoBorrowerUserFromLoanList(userLoans),
})

export default getBorrowerAndCoBorrowerUserFromLoanList
